import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import GreyArrow from "./images/next.svg";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";
import Filters from "../../../utils/filters-v2";
import getUpdatedAppliedFilters from "../../../utils/filters-v2/get-updated-applied-filters";
import { COUNTRY, DEFAULT_CITY } from "../../../constants/app-constants";
import { updateSavedFilters } from "../../../utils/helpers/update-saved-filters";
import { useHistory } from "react-router";
import { imageTypes } from "../../../utils/helpers/cdn-image-url";

const isPriceFilter = ({filter}) => {
    return (filter || {}).name === "quotedPrice";
};

const MoreCarsForYouCard = ({
    item,
    config,
    allFilters,
    resetCarListConnect,
    reloadCarListConnect,
    updateSelectedOnScreenFilterConnect,
    updateAppliedFiltersConnect,
    clearAllFiltersConnect}) => {

    const { image, title, availableCars } = item;
    const history = useHistory();
    const showFilteredCars = (customFilter, applyDirectFilter) => {
        resetCarListConnect();
        const filters = new Filters({cityCode: DEFAULT_CITY.AU.code});
        reloadCarListConnect(true);
        updateSelectedOnScreenFilterConnect("");
        updateAppliedFiltersConnect();
        if (applyDirectFilter) {
            const { payload } = filters.getListingPayload({selectedFilters: [], filters: allFilters});
            const relativeUrl = `/buy-used-cars-${COUNTRY.name}/${customFilter}${payload}`;
            window.location.href = relativeUrl;
        } else {
            const currentFilter = getUpdatedAppliedFilters(customFilter, []);
            const { relativeURL } = filters.getListingPayload({selectedFilters: currentFilter, filters: allFilters});
            updateSavedFilters(currentFilter);
            history.replace(relativeURL);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const onSelectSuggestion = (e, suggestion) => {
        const { value: displayText, filterType} = suggestion;
        if (displayText.includes("quotedPrice")) {
            e.preventDefault();
            clearAllFiltersConnect();
            const payload = `?${filterType}=${displayText}&`;
            showFilteredCars(payload, true);
        }
    };

    const renderCard = () => {
        return (
            <React.Fragment>
                <img src={getFastlyImage(config, image, imageTypes.galleryRevamp)}  />
                <div className="media-body">
                    <p styleName={"styles.heading"}>{title}</p>
                    <span styleName={"styles.subHeading"}>
                        <p>
                            {availableCars}<img src={GreyArrow} />
                        </p>
                    </span>
                </div>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            {
                isPriceFilter(item) ?
                    <span className="media" styleName={"styles.outer"} onClick={(e) => onSelectSuggestion(e, item.filter)}>
                        {renderCard()}
                    </span> :
                    <a  href={item.seoPath} className="media" styleName={"styles.outer"} onClick={(e) => onSelectSuggestion(e, item.filter)}>
                        {renderCard()}
                    </a>
            }
        </React.Fragment>
    );
};

MoreCarsForYouCard.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    item: PropTypes.object,
    allFilters: PropTypes.object,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    config: PropTypes.object
};

export default MoreCarsForYouCard;
